module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/babel-runtime/core-js/get-iterator.js
// module id = 54
// module chunks = 1 2 3